import { render, staticRenderFns } from "./CfdiOnlineBenefits.vue?vue&type=template&id=095e2b82&scoped=true&"
import script from "./CfdiOnlineBenefits.vue?vue&type=script&lang=js&"
export * from "./CfdiOnlineBenefits.vue?vue&type=script&lang=js&"
import style0 from "./CfdiOnlineBenefits.vue?vue&type=style&index=0&id=095e2b82&scoped=true&lang=css&"
import style1 from "./CfdiOnlineBenefits.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "095e2b82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/elopez/repos/FacturaIzzi/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('095e2b82')) {
      api.createRecord('095e2b82', component.options)
    } else {
      api.reload('095e2b82', component.options)
    }
    module.hot.accept("./CfdiOnlineBenefits.vue?vue&type=template&id=095e2b82&scoped=true&", function () {
      api.rerender('095e2b82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Landing/CfdiOnlineBenefits.vue"
export default component.exports